export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            关于91影视看片下载
          </h2>
        </div>

        <div className="bg-background-50 rounded-3xl p-8 md:p-12 border border-background-200/60">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-primary-500 mx-auto mb-6">
              <i className="ri-movie-2-line text-white text-2xl md:text-3xl"></i>
            </div>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              91影视看片下载是专注于<strong>安卓手机影视APP</strong>领域的服务平台，致力于为广大影迷提供安全、便捷的<strong>看片软件下载</strong>渠道与最新影视资讯。
              我们严格筛选并推荐优质的<strong>免费影视APP</strong>，确保每一款推荐的手机影视APP都经过安装测试与安全检测，让用户放心下载、安心追剧。
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              平台自上线以来，始终秉承"免费、高清、全品类"的核心理念，聚合超过<strong>30,000部</strong>高清影视资源，
              涵盖热门电视剧、最新电影、综艺娱乐、动漫番剧及纪录片等内容类型，每日保持<strong>200+</strong>的内容更新频率。
              无论您是剧荒求推荐的追剧达人，还是寻找稳定看片工具的新用户，91影视看片下载都是您值得信赖的一站式影视服务平台。
            </p>

            <div className="flex flex-wrap justify-center gap-6 md:gap-12">
              <div className="text-center">
                <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">3年+</div>
                <div className="text-sm text-foreground-500 mt-1">稳定运营</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">500万+</div>
                <div className="text-sm text-foreground-500 mt-1">累计用户</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">99.7%</div>
                <div className="text-sm text-foreground-500 mt-1">用户好评率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}